import React, { useState, useContext } from "react"
import Grid from "../shared/grid"
import usePlatformBlocks from "../shared/hooks/usePlatformBlocks"
import {
  PlatformBlocks,
  Title,
  TitleDescription,
  LinkContainer,
  LinkStyle,
  OutlineLinkStyle,
} from "./key-features.style"
import Link from "../shared/link"
import {Spacer} from '../../design-system/atoms/layout-primitives'
import Cards from "./key-features.cards"

import VisibilityProvider from "../shared/visibility-provider"
import { UIContext } from "../shared/layout"

export default function KeyFeatures() {
  const platformBlocksImage = usePlatformBlocks()

  const {
    state: { disableAnimations },
  } = useContext(UIContext)

  const [isVisible, _setIsVisible] = useState(false)
  const setIsVisible = state => {
    _setIsVisible(state)
  }

  return (
    <VisibilityProvider onChange={setIsVisible}>
      <Grid>
        <PlatformBlocks
          fluid={platformBlocksImage.childImageSharp.fluid}
          isVisible={isVisible}
          disableAnimations={disableAnimations}
        />

        <Title isVisible={isVisible} disableAnimations={disableAnimations}>
          Features of <span>Our Mapping Platform</span>
        </Title>

        <TitleDescription
          isVisible={isVisible}
          disableAnimations={disableAnimations}
        >
          Powered through a single CMS application, Mappedin’s platform provides
          end-to-end solutions for creating, maintaining, and visualizing your
          property maps.
        </TitleDescription>

        <Cards isVisible={isVisible} disableAnimations={disableAnimations} />
        <LinkContainer
          isVisible={isVisible}
          disableAnimations={disableAnimations}
        >
          <Link
            internal={true}
            href={"/mapping/applications/"}
            styleModifier={LinkStyle}
          >
            View Pre-Built Apps
          </Link>
          <Link
            internal={true}
            styleModifier={OutlineLinkStyle}
            href={"/mapping/developer-tools/"}
          >
            View Developer Tools
          </Link>
        </LinkContainer>
        <Spacer height={{sm: '48px', md: '64px', lg: '96px'}} />
      </Grid>
    </VisibilityProvider>
  )
}
